module.exports = __webpack_public_path__ + "static/img/partner_XVIII.c3e0eb3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/partner_XVIII.png
// module id = 5MhY
// module chunks = 9